<template>
  <div v-if="props.show">
    <div v-if="model && isDisabled" class="button-disabled">
      {{ props.text }}
    </div>

    <div v-if="model && !isDisabled" class="button" @click="click">
      {{ props.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
// import { ref } from 'vue'
import type { ButtonSimple } from '../types/configuration/ButtonSimple'
// import { updateComponentKey } from '../composables/ComponentKey'
// import iconQuestionMark from '../assets/icons/icon-question-mark.svg'

const props = defineProps<{
  model: ButtonSimple | undefined
  alt: string | undefined
  text: string | undefined
  show: boolean | undefined
  click: () => void
  isDisabled: boolean
}>()

// const isUrlValid = ref(false)
// let componentKey = updateComponentKey(
//   props,
//   () =>
//     (isUrlValid.value =
//       props.model !== undefined
//     )
// )
</script>

<style scoped lang="scss">
.button {
  background-color: var(--background-color);
  font-family: 'Noto Sans', sans-serif;
  border: 0px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  vertical-align: middle;
}

.button,
.button-disabled {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.button img,
.button-disabled img {
  width: 20px;
  height: 20px;
}
</style>
